import MainLayout from 'Components/Layout/MainLayout';
import React from 'react';
import Style from './index.module.scss';
import {useForm} from 'form-render';
import {Schema} from 'form-render/lib/type';
import {RagFlow} from './service';
import {useMutation, useQuery} from 'react-query';
import JsonForm from '../../../Components/JsonForm';
import {message} from 'antd';

const Index = () => {
    const form = useForm();

    const getData = useQuery({
        queryKey: ['RagFlow.detail'],
        queryFn: () => RagFlow.detail(),
        onSuccess: res => {
            form.setValues(res);
        },
    });

    const onSave = useMutation({
        mutationFn: RagFlow.save,
        onSuccess: () => {
            message.success('成功!');
            getData.refetch();
        },
    });

    const schema: Schema = {
        type: 'object',
        displayType: 'row',
        labelCol: 5,
        fieldCol: 14,
        properties: {
            name: {
                title: '名称',
                required: true,
                type: 'string',
            },
            endpoint: {
                title: '接口地址',
                required: true,
                type: 'string',
            },
            status: {
                title: '启用',
                required: true,
                widget: 'switch',
            },
            apiKey: {
                title: 'apiKey',
                type: 'string',
            },
            config: {
                title: '其他配置',
                type: 'string',
                widget: 'textArea',
                rules: [
                    {
                        validator: (_, value) => {
                            if (!value) return false;
                            try {
                                JSON.parse(value);
                                return true;
                            } catch {
                                return false;
                            }
                        },
                        message: '请检查json格式',
                    },
                ],
            },
        },
    };

    function onFinish(formData: RagFlow.Form) {
        onSave.mutate(formData);
    }

    return (
        <MainLayout.SpaceWrapper padding>
            <div className={Style.root}>
                <div className={Style.main}>
                    <JsonForm
                        onFinish={onFinish}
                        form={form}
                        schema={schema}
                        footer
                        loading={getData.isLoading || onSave.isLoading}
                    />
                </div>
            </div>
        </MainLayout.SpaceWrapper>
    );
};

export default Index;
